import { type OpportunitiesTab_userProfile$key } from '#app/__generated__/relay/OpportunitiesTab_userProfile.graphql.js';
import { RoutingTabs } from '#app/components/RoutingTabs/RoutingTabs.js';
import { useRouter } from '#app/hooks/useRouter.js';
import { graphql, useFragment } from '@contra/relay';
import { getRoute } from '@contra/routes';

type OpportunitiesTabProps = {
  readonly userProfileRef: OpportunitiesTab_userProfile$key;
};

export const OpportunitiesTab = ({ userProfileRef }: OpportunitiesTabProps) => {
  const { displayUsername } = useFragment<OpportunitiesTab_userProfile$key>(
    graphql`
      fragment OpportunitiesTab_userProfile on UserProfile {
        displayUsername
      }
    `,
    userProfileRef,
  );
  const { isActive } = useRouter();

  return (
    <RoutingTabs.Tab
      match={() =>
        isActive(
          getRoute('/@username/opportunities', {
            args: {
              username: displayUsername,
            },
          }),
          false,
        )
      }
      onClick={() => {}}
      to={getRoute('/@username/opportunities', {
        args: {
          username: displayUsername,
        },
      })}
    >
      Jobs
    </RoutingTabs.Tab>
  );
};
